import { createSelector } from 'reselect';
import { smartSkinScanBannerSelector } from 'selectors/testTarget/offers/smartSkinScanBanner/smartSkinScanBannerSelector';

const placementSelector = createSelector(smartSkinScanBannerSelector, smartSkinScanBanner => smartSkinScanBanner.placement);

export { placementSelector };
